interface WorkflowStepProps {
  className?: string;
}

const WorkflowStep = ({ className }: WorkflowStepProps) => (
  <svg className={className} width="24" height="12" viewBox="0 0 24 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 0C0.895431 0 0 0.895431 0 2C0 3.10457 0.89543 4 2 4H22C23.1046 4 24 3.10457 24 2C24 0.895431 23.1046 0 22 0H2ZM2 8C0.895431 8 0 8.89543 0 10C0 11.1046 0.89543 12 2 12H13C14.1046 12 15 11.1046 15 10C15 8.89543 14.1046 8 13 8H2Z"
      fill="#BDBDBD"
    />
  </svg>
);

export default WorkflowStep;
